import React from "react";
import Breadcrumb from "../components/Breadcrumb";
import DepartmentLayer from "../components/DepartmentLayer";

const DepartmentPage = () => {
  return (
    <>
    
        {/* Breadcrumb */}
        <div className="d-flex justify-content-between"><h5>Departments  </h5><Breadcrumb title="Departments" /></div>

        {/* AssignRoleLayer */}
        <DepartmentLayer />
    
    </>
  );
};

export default DepartmentPage;
